import React, { useContext, useState } from "react";
import { FaBookmark, FaRegBookmark } from "react-icons/fa";
import { FormContext } from "../../../pages/CMSRenderer/CMSRenderer";

const ServiceCard = ({
  icon,
  title = "Apply to Admission in Medicine and Science Program",
  description = "Short Description about the service shows here as an example",
  bookmarked = false,
  onBookmark,
  onViewDetails,
  onApply,
  showApplyButton = true,
}) => {
  const { currentLang } = useContext(FormContext);
  const [isBookmarked, setIsBookmarked] = useState(bookmarked);

  const handleBookmark = () => {
    // setIsBookmarked(!isBookmarked);
    if (onBookmark) {
      onBookmark();
    }
  };

  return (
    <div className="border border-outline rounded-2xl p-6 bg-white shadow-sm flex flex-col gap-4 relative">
      <div className="flex justify-between items-start">
        <div className="flex items-center">
          <div className="bg-[#E4EFF3] rounded-full w-20 h-20 flex items-center justify-center">
            {icon ? (
              icon
            ) : (
              <svg width="28" height="28" fill="none" viewBox="0 0 24 24">
                <circle
                  cx="12"
                  cy="8"
                  r="4"
                  stroke="#00747A"
                  strokeWidth="1.5"
                />
                <path
                  d="M4 20c0-2.21 3.582-4 8-4s8 1.79 8 4"
                  stroke="#00747A"
                  strokeWidth="1.5"
                />
              </svg>
            )}
          </div>
        </div>
        <button className="p-1" onClick={handleBookmark}>
          {isBookmarked ? (
            <FaBookmark className="text-primary text-2xl" />
          ) : (
            <FaRegBookmark className="text-primary text-2xl" />
          )}
        </button>
      </div>

      <div className="flex h-full flex-col">
        <h6 className="">{title}</h6>

        {/* <p
        className="text-onSurfaceVariant body mb-2"
        dangerouslySetInnerHTML={{ __html: description }}
      /> */}

        <hr className="mt-auto my-2 border-outline" />

        <div className="mt-2 flex gap-4">
          <div
            className={showApplyButton ? "w-1/2 *:w-full" : "w-full *:w-full"}
          >
            <dda-button
              button_color="default-tertiary"
              start_icon=""
              button_text={
                currentLang === "en" ? "View Details" : "عرض التفاصيل"
              }
              end_icon=""
              custom_class="w-full"
              component_mode=""
              button_id="button"
              aria_label="button"
              onclick={onViewDetails}
              button_name="button"
            ></dda-button>
          </div>
          {showApplyButton && (
            <div className="w-1/2 *:w-full">
              <dda-button
                button_color="default-primary"
                start_icon=""
                button_text={currentLang === "en" ? "Apply" : "تقديم"}
                end_icon=""
                custom_class="w-full"
                component_mode=""
                button_id="button"
                aria_label="button"
                onclick={onApply}
                button_name="button"
              ></dda-button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ServiceCard;
